import { render, staticRenderFns } from "./OneToManyFormInput.vue?vue&type=template&id=5423c07d&scoped=true&"
import script from "./OneToManyFormInput.vue?vue&type=script&lang=js&"
export * from "./OneToManyFormInput.vue?vue&type=script&lang=js&"
import style0 from "./OneToManyFormInput.vue?vue&type=style&index=0&id=5423c07d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5423c07d",
  null
  
)

export default component.exports